import Gallery from './Gallery';

export default function Home() {
  return <Gallery />;
}